import type { Listing } from './Listing';

/**
 *
 */
export interface NearbyListingsResponse {
  /**
   *
   */
  listings: Array<Listing>;
  /**
   * The geographic scope at which listings were found
   */
  scope: NearbyListingsResponseScopeEnum;
  /**
   * Display name of the resolved location (city name, province, or state)
   */
  locationName: string;
}

export enum NearbyListingsResponseScopeEnum {
  CITY = 'city',
  PROVINCE = 'province',
  STATE = 'state',
}
